import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerMobilePhoneFilter',
  pure: false
})
export class CustomerMobilePhoneFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }
    const normalizedFilter = filterValue.toLowerCase();
    return customerList.filter(customer =>
      (customer.MobilePhone || '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
